export enum AnalyticsCategory {
	BuyBookLink = 'Buy Book Link Clicked',
	GenreLink = 'Genre Link Clicked',
	BookCalendarAlert = 'Book Calendar Alert Clicked',
	Navigation = 'Navigation',
}
